export const MAX_FINANCIAL_TERM_RESIDENTIAL = 420;
export const MAX_FINANCIAL_TERM_COMMERCIAL = 240;
export const MIN_FINANCIAL_TERM = 36;
export const MIN_FINANCIAL_VALUE = 100000;

/**
 * Faixa de aluguel que a Almada garante (ENG-588). Mede o aluguel PURO — despesas adicionais, IPTU e
 * condomínio somam no Total Pacote e são a base da garantia, mas ficam de fora da faixa.
 *
 * Bloqueia nas portas de negócio NOVO (proposta, cotação). Na RENOVAÇÃO só avisa: quem renova é o
 * Operacional, sobre contrato que já existe e cuja faixa pode ter sido acordada antes da regra.
 * O Seguro Incêndio está fora — tem produto e apetite próprios.
 */
export const MIN_RENT_VALUE = 500;
export const MAX_RENT_VALUE = 20000;

export * from './GridifyFilter';
export * from './messages';
export * from './Months';
export * from './PaymentMethod';
export * from './PaymentType';
export * from './PersonType';
export * from './PropertyType';
export * from './RealEstateType';
export * from './UserRoles';
export * from './ProposalStatus';
export * from './DocumentType';
export * from './Lessor';
export * from './CaseType';
export * from './CompanyType';
export * from './economicActivityOptions';
export * from './SubscribeType';
export * from './PropertyKind';
export * from './CaseWorkflowTrigger';
export * from './TenantDuplicateResolution';
export * from './ExonerationRecommendationReason';
export * from './OccurrenceReviewVerdict';
export * from './CancellationRequest';
